
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { Keygen } from 'eosjs-keygen'
import Clipboard from 'clipboard'

export default {
components: {
Group,
Cell
},
data () {
return {
publicKey: null,
privateKey: null,
loading: false,
type: '1',
list: [
{
title: '公钥 Key',
msg: '已成功复制公钥 Key',
desc: '',
},
{
title: '私钥（请勿泄露）',
msg: '已成功复制私钥，请不要随意粘贴，避免泄露',
desc: '',
}
],
}
},
methods: {
createKey () {
this.loading = true;
Keygen.generateMasterKeys().then(keys => {
this.publicKey = keys.publicKeys.owner;
this.list[0].desc = this.publicKey;
this.privateKey = keys.privateKeys.owner;
this.list[1].desc = this.privateKey;
this.loading = false;
})
},
clickItem (item) {
this.$copyText(item.desc).then(function (e) {
alert(item.msg)
}, function (e) {
alert('复制失败')
})
},
onImgError (item, $event) {
console.log(item, $event)
}
},
created () {
}
}



// WEBPACK FOOTER //
// ./src/rsa.vue